import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate, query } from '../../lib/loopback'
import { path, concat } from 'ramda'

const queryTransform = {
  motorista: query.ilike('motorista'),
  cpf: query.like('cpf'),
  placa: query.ilike('placa'),
  mercadoria: query.ilike('mercadoria'),
  nomeEmbarcador: query.ilike('nomeEmbarcador'),
  status: query.eq('status'),
  responsavelId: query.eq('responsavelId'),
  createdAt: query.gte('createdAt'),
  dataTermino: query.gte('dataTermino'),
  createdAtFim: query.lte('createdAtFim'),
  dataTerminoFim: query.lte('dataTerminoFim'),
  ...paginate
}

const createQueryString = ({ query, paginate }) => {
  const { sort, order, ...allQuery } = query || {}
  const queryEntries = Object.entries({
    ...allQuery
  })
    .map(([key, value]) => {
      if (queryTransform[key]) {
        return queryTransform[key](value)
      }
      return [`[${key}]`, `${value}`]
    })
    .reduce((pairs, pair) => {
      if (Array.isArray(pair[0])) {
        return [...pairs, ...pair.map(([k, v]) => [`filter[where]${k}`, v])]
      }
      pairs.push([`filter[where]${pair[0]}`, pair[1]])
      return pairs
    }, [])
  const paginateEntries = Object.entries({
    ...paginate,
    ...(sort && !order && { sort }),
    ...(order && { order })
  })
    .map(([key, value]) => {
      if (queryTransform[key]) {
        return queryTransform[key](value)
      }
      return [`[${key}]`, `${value}`]
    })
    .reduce((pairs, pair) => {
      if (Array.isArray(pair[0])) {
        return [...pairs, ...pair.map(([k, v]) => [`filter[${k}]`, v])]
      }
      pairs.push([`filter[${pair[0]}]`, pair[1]])
      return pairs
    }, [])
  const newQuery = concat(queryEntries, paginateEntries)
  const urlSearchParams = new URLSearchParams(newQuery)
  return urlSearchParams.toString().length > 0 ? `?${urlSearchParams}` : ''
}

const relatoriosRepository = createRepository({
  path: 'relatorios',
  restApi,
  queryTransform,
  getErrorMessage: response => path(['data', 'error', 'message'], response)
})

relatoriosRepository.criarRelatorioSolicitacoes = filter => {
  return restApi.post(`/relatorios/solicitacoes${createQueryString(filter)}`)
}

relatoriosRepository.criarRelatorioTarefas = filter => {
  return restApi.post(`/relatorios/tarefas${createQueryString(filter)}`)
}

export default relatoriosRepository
